<template>
  <div>
    <div class="flex flex_gap">
      <div class="form-group">
        <label for="">Руб</label>
        <input @change="checkSum" v-model="mainIncashment.sum" type="number" class="form-control">
      </div>
      <div class="form-group">
        <label for="">USDT</label>
        <input @change="checkSum" v-model="mainIncashment.usdt" type="number" class="form-control">
      </div>
      <div class="form-group">
        <label for="">Курс</label>
        <input v-model="mainIncashment.rate" type="number" disabled class="form-control">
      </div>
      <div class="form-group">
        <label for="">Сумма инкассаций</label>
        <input type="number" v-model="mainIncashment.checksum" disabled
               :class="{'form-control big_border': true,
               'border-success': +mainIncashment.checksum === +mainIncashment.sum,
               'border-warning': +mainIncashment.checksum !== +mainIncashment.sum,
        }">
      </div>
      <div class="form-group flex-grow-1">
        <label for="">Дивизионы</label>
        <multiselect
          :options="divisions"
          @input="addDivision"
          :multiple="false"
          label="title"
          track-by="title"
          placeholder="Выберите дивизион"
          select-label="Выбрать"
          deselect-label="Удалить"
        />
      </div>
    </div>
    <div class="mt-1 flex flex_gap">
      <div class="date_select">
        <DateSelectProps :onSelect="(d) => date = d" :disabled="true"/>
      </div>
      <input type="text" v-model="mainIncashment.send_address" placeholder="Откуда" class="form-control">
      <input type="text" v-model="mainIncashment.receive_address" placeholder="Куда" class="form-control">
    </div>
    <div class="mt-2">
      <div class="input-group" v-for="(d,i) in selectedDivisions">
        <input type="text" disabled v-model="d.title" class="form-control">
        <input type="number" @change="checkSum" v-model="d.sum" placeholder="сумма" class="form-control">
        <div class="input-group-append">
          <button class="btn btn-default" @click="removeDivision(i)">
            <i class="icon-fa icon-fa-remove"/>
          </button>
        </div>
      </div>
    </div>
    <div class="mt-1 text-right" v-if="selectedDivisions.length">
      <LoadingButton
        title="Сохранить"
        :loading="loading"
        color="white"
        :onClick="() => save()"
        className="btn btn-success"
      />
    </div>
  </div>
</template>

<script>

import Multiselect from "vue-multiselect";
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import api from "@/api";
import DateSelectProps from "@/views/reports/components/DateSelectProps.vue";

export default {
  components: {
    DateSelectProps,
    LoadingButton,
    Multiselect,
  },
  data() {
    return {
      loading: false,
      selectedDivisions: [],
      divisions: [],
      date: null,
      mainIncashment: {
        sum: 0,
        usdt: 0,
        rate: 1,
        checksum: 0,
        send_address: null,
        receive_address: null,
      }
    }
  },
  created() {
    this.divisions = _.orderBy(Object.values(this.$AllDivisions).filter((d) => d.is_active), 'title');
  },
  methods: {
    checkSum() {
      this.mainIncashment.rate = this.mainIncashment.usdt ? Math.round(+this.mainIncashment.sum / +this.mainIncashment.usdt * 100) / 100 : 1;
      this.mainIncashment.checksum = this.selectedDivisions.reduce((acc, d) => +acc + +d.sum, 0);
    },
    async save() {
      if (!this.date) {
        toastr['warning']('Укажите дату', 'Ошибка');
        return;
      }
      if (!this.selectedDivisions.length) {
        toastr['warning']('Добавьте дивизион', 'Ошибка');
        return;
      }
      if (this.selectedDivisions.find((d) => !d.sum || +d.sum < 0)) {
        toastr['warning']('Неверная сумма в дивизионах', 'Ошибка');
        return;
      }
      if (!this.mainIncashment.usdt || +this.mainIncashment.usdt < 0) {
        toastr['warning']('Укажите USDT', 'Ошибка');
        return;
      }
      if (!this.mainIncashment.sum || +this.mainIncashment.sum < 0) {
        toastr['warning']('Укажите Руб.', 'Ошибка');
        return;
      }
      if (+this.mainIncashment.checksum !== +this.mainIncashment.sum) {
        toastr['warning']('Сумма не совпадает', 'Ошибка');
        return;
      }
      this.loading = true;
      const {data} = await api.post('/reports/updateIncome', {
        action: 'addGroupIncome',
        date: this.date,
        mainIncome: this.mainIncashment,
        divisions: this.selectedDivisions
      });
      if (data.success) {
        toastr['success'](data.message || 'Сохранено');
        this.selectedDivisions = [];
        this.mainIncashment = {
          sum: 0,
          usdt: 0,
          rate: 1,
          checksum: 0,
          send_address: null,
          receive_address: null,
        };
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.loading = false;
    },
    removeDivision(index) {
      delete this.selectedDivisions[index];
      this.selectedDivisions = this.selectedDivisions.filter((d) => d);
    },
    addDivision(d) {
      if (!this.selectedDivisions.find((div) => d.id === div.id)) {
        this.selectedDivisions.push({
          id: d.id,
          title: d.title,
          user_id: d.user_id,
          sum: 0
        });
      }
    }
  }
}

</script>

<style scoped>

.flex_gap {
  gap: 10px;
}

.date_select {
  width: 375px;
}

.big_border {
  border: 3px solid;
}
</style>
